import(/* webpackMode: "eager" */ "/codebuild/output/src2220634010/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
